import React, { useCallback, useState } from "react";
import { Maybe } from "true-myth";
import { map, pipe, prepend, values } from "ramda";

import Button, { ButtonColor } from "components/shared/button";
import Dropdown, { DROPDOWN_SIZE, IOption } from "components/shared/dropdown";
import Modal from "components/shared/modal";
import Warning from "components/shared/warning";
import styled from "styles/styled_components";
import { ITemplatesKeyed } from "types/reducers";
import { ITemplate } from "types/templates";
import useFormOnSubmit from "helpers/hooks/useFormOnSubmit";

const StyledWrapper = styled.div`
  margin-bottom: ${(props) => props.theme.spacing.large};
`;

const UNSELECTED: IOption<string> = {
  id: "unselected",
  label: "Select a Template",
  meta: "unselected",
};

const buildTemplateOptions = pipe(
  // @ts-expect-error TODO please fix this error
  values,
  map(
    ({ name, uuid }: ITemplate): IOption<string> => ({
      id: uuid,
      label: name,
      meta: uuid,
    })
  ),
  prepend(UNSELECTED)
);

interface IOpenTemplateProps {
  isSchedulePopulated: boolean;
  onClose: () => void;
  openTemplate: (templateId: string) => void;
  templates: ITemplatesKeyed;
}

export default function OpenTemplate({
  isSchedulePopulated,
  onClose,
  openTemplate,
  templates,
}: IOpenTemplateProps) {
  // Dropdown Options
  const [selectedOption, setOption] = useState(UNSELECTED);
  const onOptionClick = useCallback(
    (option: Maybe<IOption<string>>) => {
      option.map((opt) => {
        setOption(opt);
      });
    },
    [setOption]
  );
  // @ts-expect-error TODO please fix this error
  const options = buildTemplateOptions(templates);

  // Form Submit
  const onSubmit = useCallback(() => {
    openTemplate(selectedOption.meta);
    onClose();
  }, [selectedOption]);
  const handleSubmit = useFormOnSubmit(onSubmit);

  let warning;
  if (isSchedulePopulated && selectedOption !== UNSELECTED) {
    warning = (
      <Warning align="center">
        Opening a template will overwrite your current schedule.
      </Warning>
    );
  }

  return (
    <Modal title="Open Template" onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <StyledWrapper>
          <Dropdown
            dropdownName="Templates"
            options={options}
            onOptionClick={onOptionClick}
            currentOption={selectedOption}
            size={DROPDOWN_SIZE.FULL}
          />
          {warning}
        </StyledWrapper>
        <Button
          label="Cancel"
          buttonColor={ButtonColor.GRAY}
          onClick={onClose}
        />
        <Button
          label="Open"
          disabled={selectedOption === UNSELECTED}
          type="submit"
          buttonColor={ButtonColor.BLUE}
        />
      </form>
    </Modal>
  );
}
